import { useEffect, useState } from "react";
import { api, imgSrc } from "@/lib/api";
import { Header, Hero, Footer } from "@/components/site/Frame";
import { Gallery } from "@/components/site/Gallery";
import { Packs, Process, Addons, Owners, Faq } from "@/components/site/Sections";
import { Testimonials, Availability, InstagramStrip } from "@/components/site/Extras";
import { Contact } from "@/components/site/Contact";

const plus14 = () => { const d = new Date(); d.setDate(d.getDate() + 14); return d.toISOString().slice(0, 10); };

const setMeta = (attr, key, val) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", val || "");
};

const applySeo = (s) => {
  if (!s) return;
  document.title = s.title;
  setMeta("name", "description", s.description);
  setMeta("property", "og:title", s.title);
  setMeta("property", "og:description", s.description);
  setMeta("property", "og:image", imgSrc(s.image));
  setMeta("property", "og:type", "website");
};

export default function Landing() {
  const [c, setC] = useState(null);
  const [occasion, setOccasion] = useState("");
  const [addons, setAddons] = useState([]);
  const [date, setDate] = useState(plus14());

  useEffect(() => {
    api.get("/content").then(({ data }) => {
      setC(data);
      applySeo(data.seo);
      const f = data.packs.items.find((p) => p.featured) || data.packs.items[0];
      setOccasion(f ? f.occasion : data.contact.other_occasion);
    });
  }, []);

  if (!c) return <div className="loading-screen" data-testid="landing-loading">amore<i>moment</i></div>;

  const toggleAddon = (name) => setAddons((a) => (a.includes(name) ? a.filter((x) => x !== name) : [...a, name]));
  const calOn = !!c.calendar?.enabled;
  const blocked = calOn ? c.calendar.blocked || [] : [];

  return (
    <>
      <Header c={c} />
      <div className="wrap">
        <main>
          <Hero c={c.hero} />
          <Gallery c={c.gallery} />
          <Packs c={c.packs} onPick={setOccasion} />
          <Process c={c.process} />
          <Addons c={c.addons} selected={addons} onToggle={toggleAddon} />
          <Owners c={c.owners} />
          {c.testimonials?.enabled && c.testimonials.items.length > 0 && <Testimonials c={c.testimonials} />}
          {c.instagram?.enabled && c.instagram.items.some((it) => it.image) && <InstagramStrip c={c.instagram} />}
          <Faq c={c.faq} />
          {calOn && <Availability c={c.calendar} date={date} onPick={setDate} />}
          <Contact c={c} occasion={occasion} setOccasion={setOccasion} addons={addons} onToggle={toggleAddon} date={date} setDate={setDate} blocked={blocked} />
        </main>
        <Footer c={c} />
      </div>
    </>
  );
}
